module.exports = __webpack_public_path__ + "static/frame-open-source-720133de11f12f4e8fa05c24e2977ae4.png";